@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.destinations

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.locationpoint.LocationPointDto
import com.narbase.letsgo.web.dto.voiceassistant.CurrentLocationDto


object SearchPassengerPointsEndpoint :
    EndPoint<SearchPassengerPointsEndpoint.Request, SearchPassengerPointsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String,
        val includeAddress: Boolean? = false,
        val passengerLat: Double? = null,
        val passengerLng: Double? = null,
        val searchCenter: CurrentLocationDto? = null,
    )

    class Response(
        val passengerDestinations: Array<LocationPointDto>,
    )
}